import { MetricData } from "src/pages/reports/types/metric-universal-display-card.types";
import { ReportViewCustomizeContextType } from "../components/manage-clients/manage-client-views";
import { ReportComponentType } from "../components/manage-clients/customize-view/report-view-wrapper";

/** Slot order: 0=yellow, 1=blue, 2=green, 3=red */
function getSlotIndexFromColor(color: string): number {
  if (color.includes('yellow')) return 0;
  if (color.includes('blue')) return 1;
  if (color.includes('green')) return 2;
  if (color.includes('red')) return 3;
  return 0;
}

/**
 * Updates componentDefaults['metric-universal-display'] when the user selects a new metric
 * for a slot via the metric dropdown (handleSelect). Creates/updates context entries in
 * slot order: [yellow, blue, green, red]; empty slots are stored as ''.
 */
export const handleMetricUniversalDisplayDefaultSelection = (
  context: ReportViewCustomizeContextType,
  metric: MetricData,
  selectedMetricName: string
) => {
  const { componentDefaults, handleDefaultSelectionChange } = context;
  const slotIndex = getSlotIndexFromColor(metric.color);
  console.log(metric, selectedMetricName);

  const old = componentDefaults['metric-universal-display'] ?? [];
  if (old.includes(selectedMetricName)) {
    old.splice(old.indexOf(selectedMetricName), 1);
  }
  old.splice(0, 0, selectedMetricName);

  const slotArray: string[] = [];
  for (let i = 0; i < 4; i++) {
    slotArray[i] = (old[i] ?? '') as string;
  }

  // Clear selectedMetricName from its current slot if it's moving
  for (let i = 0; i < 4; i++) {
    if (slotArray[i] === selectedMetricName) slotArray[i] = '';
  }
  slotArray[slotIndex] = selectedMetricName;

  handleDefaultSelectionChange('metric-universal-display', slotArray);
};

/**
 * Updates componentDefaults for components that have a single default metric.
 * Use in the component's handleSelect/onMetricChange to write [selectedMetric] into context.
 */
export const handleComponentDefaultMetricSelection = (
  context: ReportViewCustomizeContextType,
  componentType: ReportComponentType,
  selectedMetric: string
) => {
  context.handleDefaultSelectionChange(componentType, [selectedMetric]);
};